import { useCallback, useState } from "react";
import { useAccount, useSignMessage } from "wagmi";
import { getHubNonce, hubLogin } from "@/api";

const key = (a) => `flame.hub_token.${a?.toLowerCase()}`;

export function useHubSession() {
  const { address } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const [, bump] = useState(0);
  const token = address ? localStorage.getItem(key(address)) : null;

  const signIn = useCallback(async () => {
    if (!address) throw new Error("Connect your wallet first");
    const message = await getHubNonce(address);
    const signature = await signMessageAsync({ message });
    const t = await hubLogin(address, signature);
    localStorage.setItem(key(address), t);
    bump((n) => n + 1);
    return t;
  }, [address, signMessageAsync]);

  const clear = useCallback(() => { if (address) localStorage.removeItem(key(address)); bump((n) => n + 1); }, [address]);

  // Runs fn(token), signing in first (or again after a 401).
  const withSession = useCallback(async (fn) => {
    let t = token || (await signIn());
    try { return await fn(t); } catch (e) {
      if (e?.response?.status !== 401) throw e;
      clear();
      t = await signIn();
      return fn(t);
    }
  }, [token, signIn, clear]);

  return { address, token, signIn, withSession, clear };
}

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.shortMessage || e?.message || fallback;
};
